export default {
    setData: "modals-action.set.data",
    toggle: "modals-action.toggle",
    open: "modals-action.open",
    stage: {
        set: "modals-action.stage.set",
        update: "modals-action.stage.update",
        toggleButton: "modals-action.stage.toggle.button",
    }
}